export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
}

export const defaultActions = {
  isCreate: false,
  isCreateAndSave: false,
  isEdit: false,
  isEditAndSave: false,
  isRemove: false,
  isRemoveAndSave: false,
}
